module.exports = __webpack_public_path__ + "img/light.26b3181b.png";